import { QuickLink } from '../../../../components/common/quick-links/QuickLink';
import {
	ASSET_LINK_TYPE_ID,
	EMAIL_LINK_TYPE_ID,
	EXTERNAL_LINK_TYPE_ID,
	INTERNAL_LINK_TYPE_ID,
	PHONE_LINK_TYPE_ID,
} from '../../../../contentful';
import { IQuickLinkItem } from '../../../../ui';

export default function renderQuickLinkItem(linkItem: IQuickLinkItem) {
	switch (linkItem.type) {
		case INTERNAL_LINK_TYPE_ID:
			return (
				<QuickLink
					key={linkItem.key}
					type="internal"
					url={linkItem.url}
					ariaLabel={linkItem.title}
				>
					{linkItem.title}
				</QuickLink>
			);
		case EXTERNAL_LINK_TYPE_ID:
			return (
				<QuickLink
					key={linkItem.key}
					type="external"
					url={linkItem.url}
					ariaLabel={linkItem.title}
				>
					{linkItem.title}
				</QuickLink>
			);
		case ASSET_LINK_TYPE_ID:
			return (
				<QuickLink
					key={linkItem.key}
					type="asset"
					url={linkItem.url}
					ariaLabel={linkItem.title}
				>
					{linkItem.title}
				</QuickLink>
			);
		case EMAIL_LINK_TYPE_ID:
			return (
				<QuickLink
					key={linkItem.key}
					type="email"
					url={`mailto:${linkItem.address}`}
					ariaLabel={linkItem.title}
				>
					{linkItem.title}
				</QuickLink>
			);
		case PHONE_LINK_TYPE_ID:
			return (
				<QuickLink
					key={linkItem.key}
					type="phone"
					url={`tel:${linkItem.title}`}
					ariaLabel={linkItem.title}
				>
					{linkItem.title}
				</QuickLink>
			);
		default:
			return null;
	}
}
